import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import Popper from "popper.js";
import {getSingleInputByNameV3} from "../../helpers/forms/formInputsHelpers";

function initPublicSignContractView() {
	const confirmContractButton = document.querySelector('.confirm-contract-button');

	confirmContractButton.addEventListener('click', confirmContract);

	/**
	 * @type {HTMLInputElement}
	 */
	const confirmCheckbox = document.querySelector('#confirm-contract-checkbox');

	confirmCheckbox.addEventListener('change', () => {
		scrollContractToSignature()
		handleContractAcceptedCheck()
	});

	/**
	 * @type {HTMLInputElement}
	 */
	const contractContainer = document.querySelector('.contract-container');

	// Setup signature input and popper
	/** @var {HTMLElement} */
	const signatureInputContainer = document.querySelector('.contract-signature-input-container');
	/** @var {HTMLInputElement} */
	const signatureInput = signatureInputContainer.querySelector('input[name="signature"]');
	const confirmSignatureButton = signatureInputContainer.querySelector('button');

	signatureInput.addEventListener('keypress', e => {
		if (e.key === 'Enter') {
			handleSignatureInput();
		}
	})

	confirmSignatureButton.addEventListener('click', () => {
		handleSignatureInput()
	})

	signatureInput.addEventListener('focus', () => {
		signatureInputContainer.classList.add('focused');
	});

	// Unfocus signature input
	setInterval(() => {
		if (signatureInput !== document.activeElement) {
			signatureInputContainer.classList.remove('focused');
		}
	}, 256)

	// Setup popper for signature
	const signatureContainer = contractContainer.querySelector('.signer-signature-name');

	new Popper(signatureContainer, signatureInputContainer, {
		positionFixed: true,
		placement: 'top-start',
		onCreate() {
			// Make visible once positioned
			signatureInputContainer.classList.remove('d-none')
		}, onUpdate(data) {
			if (data.hide) {
				signatureInputContainer.classList.add('opacity-0');
			} else {
				signatureInputContainer.classList.remove('opacity-0');
			}
		}
	})

	// Setup up popper for skip stipend
	const totalCompensationContainer = contractContainer.querySelector('.total-compensation-container');
	const skipStipendContainer = document.querySelector('.skip-stipend-input-container');

	// Check if both skip stipend container and it's target exists
	if (totalCompensationContainer && skipStipendContainer) {
		// And init popper and listeners
		new Popper(totalCompensationContainer, skipStipendContainer, {
			positionFixed: true,
			placement: 'bottom-start',
			onCreate() {
				// Make visible once positioned
				skipStipendContainer.classList.remove('d-none')
			}, onUpdate(data) {
				if (data.hide) {
					skipStipendContainer.classList.add('opacity-0');
				} else {
					skipStipendContainer.classList.remove('opacity-0');
				}
			}
		})

		skipStipendContainer.querySelectorAll('input[type=radio]')
			.forEach(input => {
				input.addEventListener('change', () => handleContractAcceptedCheck());
			})
	}

	// Initial render
	handleSignatureInput();
	handleContractAcceptedCheck();

	/** Methods */

	function handleSignatureInput() {
		const name = signatureInput.value.trim();

		const signatureContainer = contractContainer.querySelector('.signer-signature-name');

		if (name.length === 0) {
			// Add an empty space so the signature container never collapses
			signatureContainer.innerHTML = "&nbsp;";
		} else {
			// Or fill in the actual name
			signatureContainer.innerText = name;
		}

		handleContractAcceptedCheck();
	}

	function scrollContractToSignature() {
		contractContainer.scrollTo({
			top: contractContainer.scrollHeight + 100, // magic number
			left: contractContainer.scrollWidth + 100, // magic number
			behavior: 'smooth',
		})
	}

	/**
	 * Checks if the user has signed and accepted the contract
	 */
	function handleContractAcceptedCheck() {
		const signatureContainer = contractContainer.querySelector('.signer-signature-name');
		const contractAccepted = confirmCheckbox.checked;
		// Check the actual signature in the contract, not on the input
		const contractSigned = signatureContainer.innerText.trim().length > 0;

		// Always check for contract signature and acceptance checkbox
		const requirementsToCheck = [
			contractAccepted,
			contractSigned,
		];

		// If we have a skip stipend and compensation, also check that a choice
		// has been made regarding stipend
		if (totalCompensationContainer && skipStipendContainer) {
			const skipStipendValue = getSingleInputByNameV3(skipStipendContainer, 'skip_stipend');

			const skipStipendChoiceExists = skipStipendValue !== null;
			requirementsToCheck.push(skipStipendChoiceExists);
		}

		let allRequirementsMet = true;

		for (const requirement of requirementsToCheck) {
			if (requirement === false) {
				allRequirementsMet = false;
				break;
			}
		}

		if (allRequirementsMet) {
			confirmContractButton.disabled = false;
			confirmContractButton.title = '';
		} else {
			confirmContractButton.disabled = true;
			confirmContractButton.title = 'You must read and agree to the contract to continue';
		}
	}

	function confirmContract() {
		if (confirmCheckbox.checked === false) {
			return;
		}

		const signatureContainer = contractContainer.querySelector('.signer-signature-name');
		const confirmRoute = getSingleInputByNameV3(document.body, 'confirm_route');

		loading();

		const skipStipendValue = getSingleInputByNameV3(skipStipendContainer, 'skip_stipend');

		Axios.post(confirmRoute, {
			signature: signatureContainer.innerText.trim(),
			skip_stipend: skipStipendValue ? (skipStipendValue === '1') : false,
		})
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initPublicSignContractView}
